import { ServerSettings, Setting } from '../../types/Settings';
import { TariffPaymentMethodSettingValue } from '../../types/tariffTypes';
import { QualitativeAssessmentRangeRow } from '../../views/Configurations/academics/hooks/useQualitativeAssessmentRangeColumns';
import { CoursesFeaturesOptions } from '../../views/Configurations/academics/interfaces/courses-features.interface';
import { QualitativeAssessmentRangeResponse } from '../../views/Configurations/academics/interfaces/qualitative-assessment-range.interface';
import { FormDataFinantial } from '../../views/Configurations/finantial/interfaces/finantial-config.interface';
import { IdentificationTypeResponse } from '../../views/TeacherManagement/TeacherActivation/types';
import { SETTINGS } from '../endpoints';
import request from '../request';

type TeacherClassManagementConfig = {
  rescheduleClassAllowed: boolean;
  updateClassroomAllowed: boolean;
};

/**
 * Obtiene el valor de la configuracion de la variable de tiempo
 */
export function getTimeVariableConfig() {
  return request<Setting>(SETTINGS.TIME_STATUS_LESSONS);
}

/**
 * Obtiene el valor de la configuracion de las opciones de finanzas
 */
export function getFinantialConfig() {
  return request<TariffPaymentMethodSettingValue>(SETTINGS.FINANTIAL);
}
/**
 * Obtener form data de opciones de pagos
 */
export function getFinantialConfigFormData() {
  return request<FormDataFinantial>(SETTINGS.FINANTIAL_FORM_DATA);
}

/**
 * Actualiza el valor de la configuracion de las opciones de finanzas.
 * Sólo lleva los campos de propiedad de Configuración General: los de
 * intereses/cuotas/abonos son del Portal Financiero y el backend los ignora
 * aunque vinieran igual (ver `SettingsService.saveGeneralPaymentOptions`).
 */
export function updateFinantialConfig(
  data: Partial<TariffPaymentMethodSettingValue>,
) {
  return request<TariffPaymentMethodSettingValue>(SETTINGS.FINANTIAL, {
    method: 'POST',
    data,
  });
}

/**
 * Actualiza el valor de la configuracion de la variable de tiempo
 */
export function updateTimeVariableConfig(newValue: string | number) {
  return request<Setting>(SETTINGS.TIME_STATUS_LESSONS, {
    method: 'POST',
    data: {
      timeStatusLessons: Number(newValue),
    },
  });
}

/**
 * Obtiene la fecha y hora del server con su offset segun la config de la univ
 */
export const getServerTimezone = () => {
  const url = SETTINGS.TIMEZONE;
  return request<ServerSettings>(url);
};

/**
 * Obtiene los registros de evaluaciones qualitativas
 */
export function getQualitativeAssessmentRangeConfig() {
  return request<QualitativeAssessmentRangeResponse>(
    SETTINGS.QUALITATIVE_ASSESSMENT_RANGE,
  );
}

/**
 * Actualiza los registros de evaluaciones qualitativas
 */
export function updateQualitativeAssessmentRangeConfig(
  records: QualitativeAssessmentRangeRow[],
) {
  return request<void>(SETTINGS.QUALITATIVE_ASSESSMENT_RANGE, {
    method: 'POST',
    data: { records },
  });
}

/**
 * Obtiene el valor de la configuracion de las caracteristicas de las asignaturas
 */
export function getCoursesFeaturesConfig() {
  return request<CoursesFeaturesOptions>(SETTINGS.COURSES_FEATURES);
}

/**
 * Actualiza el valor de la configuracion de las caracteristicas de las asignaturas
 */
export function updateCoursesFeaturesConfig(data: CoursesFeaturesOptions) {
  return request<CoursesFeaturesOptions>(SETTINGS.COURSES_FEATURES, {
    method: 'POST',
    data,
  });
}

/**
 * Obtiene la configuración de administración de clases para profesores
 */
export function getTeacherClassManagementConfig() {
  return request<TeacherClassManagementConfig>(
    SETTINGS.TEACHER_CLASS_MANAGEMENT,
  );
}

/**
 * Actualiza la configuración de administración de clases para profesores
 */
export function updateTeacherClassManagementConfig(
  data: TeacherClassManagementConfig,
) {
  return request<TeacherClassManagementConfig>(
    SETTINGS.TEACHER_CLASS_MANAGEMENT,
    {
      method: 'POST',
      data,
    },
  );
}

/**
 * Obtiene el valor de los tipos de identificacion habilitados por region
 */
export function getIdentificationTypeConfig() {
  return request<IdentificationTypeResponse>(SETTINGS.IDENTIFICATION_TYPES());
}

export interface TariffTabsConfig {
  subsidiesEnabled: boolean;
  partnershipsEnabled: boolean;
}

/**
 * Indica si las pestañas Subsidios y Convenios (Aranceles y Matrícula) están
 * habilitadas para el tenant actual.
 */
export function getTariffTabsConfig() {
  return request<TariffTabsConfig>(SETTINGS.TARIFF_AND_TUITION_TABS_CONFIG);
}
